import { createApp } from 'vue';
import cmpSuperBundleView from '../vue/SuperBundleView.vue';

window.SuperBundleView = (function(){
	const component = createApp(cmpSuperBundleView, {
		superBundleViewInfo: window.superBundleViewInfo
	});
	delete window.superBundleViewInfo;
	return component.mount('#component-super-bundle-view');
})();
